import React from 'react'

import { Column } from 'primereact/column'
import { Skeleton } from 'primereact/skeleton'

import { ColumnConfig } from '../../../../features/ui-config'
import { getConfigTranslation } from '../../../helper/getConfigTranslation'
import { getDataType, getFilterTemplate } from '../getter'

export function createLoadingColumns(
  configColumns: ColumnConfig[],
  checkboxen?: boolean,
  buttons?: JSX.Element,
  hasLink?: boolean,
) {
  const bodyTemplate = () => <Skeleton></Skeleton>

  const checkboxColumn = checkboxen && (
    <Column
      key="checkboxColumn"
      selectionMode="multiple"
      frozen
      alignFrozen="left"
      className="w-3rem"
    />
  )

  const navigationColumn = hasLink && (
    <Column
      key="navigationColumn"
      field="icon"
      header=""
      body={<i className="pi pi-angle-right text-primary text-2xl"></i>}
      frozen
      alignFrozen="right"
      align="right"
    />
  )

  const columns = configColumns
    .filter(column => column.enabled !== false)
    .map(column => (
      <Column
        key={column.filterField || column.field}
        align={column.align ?? 'left'}
        body={bodyTemplate}
        dataType={getDataType(column.dataType)}
        field={column.field}
        filter={column.filter ?? false}
        filterElement={getFilterTemplate(column.dataType)}
        filterMenuStyle={{ minWidth: '16em' }}
        filterPlaceholder={getConfigTranslation(column?.filterPlaceholder)}
        header={getConfigTranslation(column?.header)}
        sortable={column.sortable ?? false}
        style={{ width: column.width, minWidth: column.minWidth }}
      />
    ))

  if (checkboxColumn) {
    columns.unshift(checkboxColumn)
  }

  if (buttons) {
    columns.push(
      React.cloneElement(buttons, {
        frozen: true,
        align: 'right',
        alignFrozen: 'right',
      }),
    )
  }

  if (navigationColumn) {
    columns.push(navigationColumn)
  }

  return columns
}
